import { AFS_ORDER_DRAFT_RENEW_OR_PROCEED_API_URL } from "../components/Shared/constant";

const AfsOrderDraftRenewOrProceedAPI = (payload, accessToken) => {
  const responce = window.axios
    .post(AFS_ORDER_DRAFT_RENEW_OR_PROCEED_API_URL, payload, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + accessToken,
      },
    })
    .then(function (result) {
      return {
        ...result.data,
        status: 200,
      };
    })
    .catch(function (result) {
      return {
        ...result?.response?.data,
        status: result?.response?.status,
      };
    });
  return responce;
}

export default AfsOrderDraftRenewOrProceedAPI
